import { Outlet } from "react-router-dom";
import Header from "../Shared-Component/Header/Header";
import Footer from "../Shared-Component/Footer/Footer";
import "./AdministrationPage.scss";

const AdministrationPage = () => {

    return (
        <div>
            {/* Header */}
            <div className="header">
                <Header />
            </div>

            <div className="main-container">
                {/* Content */}
                <div className="main-content">
                    <Outlet />
                </div>

                {/* Footer */}
                <div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default AdministrationPage;
